module.exports = __webpack_public_path__ + "img/white.55eddb2a.png";